"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    //css for F&F certificates print
    '@global': {
      '@media print': {
        header: {
          display: 'none'
        },
        body: {
          '& #footer': {
            display: 'none'
          }
        }
      }
    },
    wrapper: {
      margin: '0 !important',
      lineHeight: 'normal !important',
      letterSpacing: '0.28px',
      '& .rte-smaller': {
        fontSize: '0.65em'
      },
      '& .rte-bigger': {
        fontSize: '1.35em'
      },
      '& p': {
        margin: 0
      }
    }
  };
});
var FFCertsTitleEditConfig = {
  emptyLabel: 'FF Certs Title',
  isEmpty: function isEmpty(props) {
    return !props || !props.text;
  }
};
var FFCertsTitle = function FFCertsTitle(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$linkURL = _ref.linkURL,
    linkURL = _ref$linkURL === void 0 ? null : _ref$linkURL,
    _ref$openNewTab = _ref.openNewTab,
    openNewTab = _ref$openNewTab === void 0 ? false : _ref$openNewTab,
    anchorId = _ref.anchorId;
  var classes = useStyles();
  var cleanedText = text && text.replace('<p>', '').replace('</p>', '').replace(/&nbsp;/g, ' ').trim();
  var titleEl = __jsx("h1", {
    id: anchorId,
    className: "aem-ms-title ".concat(classes.wrapper),
    dangerouslySetInnerHTML: {
      __html: cleanedText
    }
  });
  if (linkURL) {
    return __jsx("h1", {
      id: anchorId,
      className: "aem-ms-title ".concat(classes.wrapper)
    }, __jsx(_core.Link, {
      href: linkURL,
      color: "inherit",
      underline: "none",
      target: openNewTab ? '_blank' : '_self',
      dangerouslySetInnerHTML: {
        __html: cleanedText
      }
    }));
  }
  return titleEl;
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/ffcertificatestitle')(FFCertsTitle, FFCertsTitleEditConfig);
exports.default = _default;